<template>
  <div class="card policy-card soft-card">
    <div class="p-3 card-body policy-card-body" @click="handleSearch(1)">
      <div class="d-flex">
        <div class="p-2 avatar avatar-xl bg-gradient-success border-radius-md">
          <img :src="image" :alt="title" />
        </div>
        <div class="my-auto ms-3">
          <h6 class="mb-0">{{ title }}</h6>
          <div class="text-sm text-bold text-secondary">{{ subTitle }}</div>
        </div>
      </div>
      <p class="mt-3 mb-2 text-sm">
        {{ description }}
      </p>
      <hr class="horizontal dark my-2" />
      <div class="row align-items-end">
        <div class="col-6">
          <h6 class="mb-0 text-sm">{{ amount }}</h6>
          <div class="mb-0 text-sm text-secondary font-weight-bold">
            {{ $t("policyInsureds") }}
          </div>
        </div>
        <div class="col-6 text-end">
          <div class="progress policy-progress ms-auto mb-1">
            <div class="progress-bar" role="progressbar" :style="perVal()"></div>
          </div>
          <h6 class="mb-0 text-sm">{{ dateTime }} - {{ endDateTime }}</h6>
          <div class="mb-0 text-sm text-secondary font-weight-bold">
            Due date
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function parseDate(dateStr) {
  const [day, month, year] = dateStr.split(".").map(Number);
  const fullYear = year < 100 ? 2000 + year : year;
  return new Date(fullYear, month - 1, day);
}
export default {
  name: "ComplexProjectCard",
  components: {
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      default: "",
    },
    amount: {
      type: Number,
      default: 0,
    },
    endDateTime: {
      type: String,
      default: "",
    },
    members: {
      type: Array,
      default: () => [],
    },
    dropdown: {
      type: Array,
      default: () => [],
      label: String,
      route: String,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    perVal() {
      const startDate = parseDate(this.dateTime);
      const endDate = parseDate(this.endDateTime);
      const currentDate = new Date();

      const totalDuration = endDate - startDate;

      const timeElapsed = currentDate - startDate;

      const progress = (timeElapsed / totalDuration) * 100;
      if (progress <= 40) {
        return `background-color: lime; width: ${progress}%`;
      } else if (progress <= 75) {
        return `background-color: yellow; width: ${progress}%`;
      } else {
        return `background-color: red; width: ${progress}%`;
      }
    },
  },
};
</script>
<style scoped>
.policy-card {
  position: relative;
  background: var(--app-surface);
  overflow: hidden;
  border: 1px solid var(--app-border) !important;
  border-radius: 8px !important;
  box-shadow: var(--app-shadow) !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.policy-card-body {
  cursor: pointer;
}

.policy-card:hover {
  border-color: var(--app-border-strong) !important;
  box-shadow: var(--app-shadow-md) !important;
}

.policy-progress {
  width: 72%;
  margin-left: auto;
}
</style>